<template>
    <div style="box-sizing: border-box;padding-top: 20px;">
        <div class="forms">
            <div class="formTitle flx alc">
                <div class="bshu"></div>
                <div class="ftname">
                    活动基本信息
                </div>
            </div>

            <div class="formitem flx">
                <div class="finame" style="box-sizing: border-box;padding-top: 10px;">
                    <span style="color: #FF4949;">*</span>
                    <span>活动名称:</span>
                </div>
                <div>
                    <div class="ips">
                        <div class="inps">
                            <el-input :maxlength="30" v-model="forms.name" placeholder="请输入活动标题"></el-input>
                        </div>
                    </div>
                    <div class="tip">
                        最多30字
                    </div>
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>上传封面图</span>
                </div>
                <div class="ips">
                    <el-upload class="upload-demo" action="https://hrxsl.com/api/Common/oss_upload"
                        :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload1" :headers="uploadHeaders"
                        :show-file-list="false">
                        <div class="upimage">
                            <img v-if="!forms.avatar" :src="$Localimg('uploadImage.png')" alt="" />
                            <img v-else :src="$img(forms.avatar)" alt="" />
                        </div>
                    </el-upload>
                </div>
            </div>


            <div class="formitem flx">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>轮播图(banner图)</span>
                </div>
                <div>
                    <div class="ips flx alc">
                        <el-upload class="upload-demo" :show-file-list="false"
                            action="https://hrxsl.com/api/Common/oss_upload" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" :headers="uploadHeaders" v-if="imgs.length < 6">
                            <div class="upimage">
                                <img :src="$Localimg('uploadImage.png')" alt="" />
                            </div>
                        </el-upload>
                        <div class="imgs alc flx">
                            <div class="imgItme" v-for="item,index in imgs"
                                :style="(imgs.length == 6 && index == 0)?'margin-left:0' : ''">
                                <img :src="$img(item)" alt="" />
                                <div class="dels" @click="del(e)">
                                    <i style="color: #fff;font-size: 12px;" class="el-icon-delete"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tis">
                        <div class="tiitem" style="margin-left: 0;margin-top: 12px;">
                            图片单张大小不能超过3M，尺寸推荐668*388像素，最多可上传6张，支持JPG\PNG格式
                        </div>
                    </div>
                </div>
            </div>


            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>开始时间:</span>
                </div>
                <div>
                    <div class="ips flx alc">
                        <el-date-picker v-model="forms.time" type="datetime" placeholder="请设置活动的开始时间"
                            format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>结束时间:</span>
                </div>
                <div>
                    <div class="ips flx alc">
                        <el-date-picker v-model="forms.over_time" type="datetime" placeholder="请设置活动的结束时间"
                            format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>活动形式:</span>
                </div>
                <div class="ips">
                    <el-checkbox v-model="checked1" label="线下活动" border></el-checkbox>
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>活动城市:</span>
                </div>
                <div class="ips">
                    <el-cascader v-model="areaValue" :options="areaList" :props="areaProps" :placeholder="areaValue.length > 0?fullName : '请选择省/市/区'"
                        clearable @change="handleAreaChange"></el-cascader>
                </div>
            </div>

            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>活动地点:</span>
                </div>
                <div>
                    <div class="ips">
                        <div class="inps">
                            <el-input :maxlength="30" placeholder="请输入活动具体地点" v-model="forms.address"></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>是否开启多规格:</span>
                </div>
                <div class="ips">
                    <el-checkbox v-model="checked10" label="开启" border></el-checkbox>
                </div>
            </div>
            <div class="formitem flx alc">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>默认价格:</span>
                </div>
                <div>
                    <div class="ips">
                        <div class="inps">
                            <el-input type="digit" placeholder="请输入默认价格" v-model="forms.default_price"></el-input>
                        </div>
                    </div>
                </div>
            </div>

            <div class="formitem flx alc" v-if="checked10 == true">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>报名费用:</span>
                </div>
                <div>
                    <div class="bTable">
                        <div class="btTitle bdbottom flx alc">
                            <div class="btt1 bdright">
                                票种名称
                            </div>
                            <div class="btt2 bdright">
                                票价(元)
                            </div>
                            <div class="btt3">
                                操作
                            </div>
                        </div>
                        <div class="btBody">
                            <div class="btRow bdbottom flx alc" v-for="item,index in fees">
                                <div class="bip1">
                                    <input type="text" placeholder="请输入票种名称" v-model="item.name" />
                                </div>
                                <div class="bip2">
                                    <input type="number" placeholder="请输入价格" v-model="item.money" />
                                </div>
                                <div class="bip3">
                                    <img class="tabdel" :src="$Localimg('tadel.png')" alt="" @click="delThis(index)" />
                                </div>
                            </div>
                            <div class="taAdd">
                                <el-button type="primary" plain @click="plusTicket">+ 添加票种</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flx formitem">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>活动标签:</span>
                </div>
                <div>
                    <div>
                        <div class="labels flx alc">
                            <div class="labelItem" @click="forms.category_id = item.id" v-for="item,index in accate"
                                v-text="item.name" :class="forms.category_id == item.id?'catea' : ''">

                            </div>
                        </div>
                    </div>
                    <div class="tip">
                        请选择一个标签来进行展示
                    </div>
                </div>

            </div>

            <div class="formitem flx">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>活动详情:</span>
                </div>
                <div>
                    <div class="ips" style="width: 715px;">
                        <quillEditor v-model="content" ref="myQuillEditor" :options="editorOption"
                            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                            @change="onEditorChange($event)">
                        </quillEditor>
                    </div>

                </div>
            </div>
            <div class="formitem alc flx" style="margin-top: 60px;">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>售后电话:</span>
                </div>
                <div class="ips">
                    <div class="inps">
                        <el-input :maxlength="11" placeholder="请输入售后电话" v-model="forms.tel"></el-input>
                    </div>
                </div>
            </div>
            <div class="formitem flx">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>固定报名项:</span>
                </div>
                <div class="ips gts flx">
                    <div class="gitem" v-for="item,index in gdar" v-text="item"></div>
                </div>
            </div>
            <div class="formitem flx">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>报名项添加:</span>
                </div>
                <div class="ips gtns alc flx">
                    <div class="gnitem flx" v-for="item,index in gnar">
                        <div class="gnLeft" v-text="item.name">

                        </div>
                        <div class="flx alc">
                            <el-checkbox v-model="item.checked">必填</el-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="formitem alc flx">
                <div class="finame">
                    <span style="color: #FF4949;">*</span>
                    <span>是否审核:</span>
                </div>
                <div class="ips oth alc flx">
                    <div class="flx alc" style="margin-right: 14px;">
                        <el-checkbox v-model="checked3"></el-checkbox>

                    </div>
                    <div class="shne">
                        购买此票的用户需经过商家的审核才可参加活动
                    </div>
                </div>
            </div>
            <div class="formitem alc flx">
                <div class="finame">
                    <span>推荐设置</span>
                </div>
                <div class="ips oth alc flx">
                    <div class="flx alc" style="margin-right: 14px;">
                        <el-checkbox v-model="checked2"></el-checkbox>
                    </div>
                    <div class="shne">
                        允许在HR新势力平台平台曝光
                    </div>
                </div>
            </div>
            <el-dialog title="上传图片" :visible.sync="dialogVisible" width="400">
                <el-upload action="https://hrxsl.com/api/Common/oss_upload" :on-success="uploadSuccess"
                    list-type="picture-card" :file-list="fileList" :headers="uploadHeaders">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmUpload">确定插入</el-button>
                </div>
            </el-dialog>
            <div class="bot">
                <div class="flx alc jsc">
                    <el-button type="primary" plain @click="subThis(source == 2?4:3)">存为草稿</el-button>
                    <el-button type="primary" @click="subThis(source == 2?1:2)">发布</el-button>
                </div>
                <div class="rules flx alc jsc">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="torules(7)">《服务使用协议》</b><b
                            class="cursor" style="color:#007AFF" @click="torules(8)">《用户行为及内容规范》</b><b class="cursor"
                            style="color:#007AFF" @click="torules(9)">《版权许可服务协议》</b>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        quillEditor
    } from 'vue-quill-editor'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.bubble.css'

    import {
        beShop,
        getActivityCate,
        pubActivity,
        getAcDetail
    } from "@/api/index.js"
    import areaList from '@/assets/area.json'
    export default {
        name:"editActivity",
        components: {
            quillEditor
        },
        data() {

            return {
                gdar: ['姓名', "手机号", '邮箱', "企业名称", '岗位职务', "行业类型", '所在地区'],
                areaValue: [],
                gnar: [{
                        name: "推荐人",
                        checked: false,
                        id: 1
                    },
                    {
                        name: "学历",
                        checked: false,
                        id: 2
                    },
                    {
                        name: "QQ",
                        checked: false,
                        id: 3
                    },
                    {
                        name: "微信",
                        checked: false,
                        id: 4
                    },
                    {
                        name: "需求",
                        checked: false,
                        id: 5
                    },
                    {
                        name: "性别",
                        checked: false,
                        id: 6
                    },
                    {
                       name: "身份验证",
                       checked: false,
                       id: 7
                    }
                ],
                areaList: areaList,
                checked10: false,
                // 级联配置
                areaProps: {
                    value: 'value',
                    label: 'label',
                    children: 'children'
                },
                accate: [],
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
                fees: [],
                forms: {
                    name: "",
                    category_id: "",
                    avatar: "",
                    time: "",
                    over_time: "",
                    is_type: 1,
                    address: '',
                    spec_type: '',
                    default_price: '',
                    province_id: "",
                    area_id: "",
                    city_id: "",
                    tel: "",
                    bg_status: "",
                    is_check: '',
                    content: "",
                    hot_status: ''
                },
                hasRead: false,
                value1: "",
                imgs: [],
                checked1: true,
                checked2: true,
                checked3: true,
                // 富文本html内容
                content: '',
                // 编辑器配置
                editorOption: {
                    placeholder: '请输入正文内容...',
                    theme: 'snow', // snow(带工具栏) / bubble(极简悬浮)
                    modules: {
                        toolbar: {
                            container: [
                                [{
                                    'header': [1, 2, 3, false]
                                }], // 标题
                                ['bold', 'italic', 'underline', 'strike'], // 加粗、斜体、下划线、删除线
                                [{
                                    'list': 'ordered'
                                }, {
                                    'list': 'bullet'
                                }], // 有序/无序列表
                                [{
                                    'align': []
                                }], // 对齐
                                [{
                                    'color': []
                                }, {
                                    'background': []
                                }], // 字体颜色、背景色
                                ['link', 'image'], // 链接、图片
                                ['clean'] // 清除格式
                            ],
                            // 覆盖默认图片点击事件，打开element上传弹窗
                            handlers: {
                                image: () => this.openUploadDialog()
                            }
                        }
                    }
                },
                // 图片上传弹窗
                dialogVisible: false,
                uploadUrl: '/api/upload/img', // 你的后端图片上传接口
                fileList: [],
                uploadImgUrl: [], // 上传成功后的图片地址
                id: "",
                fullAddress:"",
                source: "",
                fullName:""
            }
        },
        created() {
            this.id = this.$route.query.id
            this.source = this.$route.query.source
            this.getDetail()
        },
        methods: {
            del(e){
                this.imgs.splice(e,1)
            },
            getDetail() {
                let that = this
                let data = {}
                data.id = that.id
                data.source = that.source
                console.log(data)
                getAcDetail(data).then((res) => {
                    console.log("detail", res)
                    if (res.code == 1) {
                        that.forms.name = res.data.info.name
                        that.forms.category_id = res.data.info.category_id
                        that.forms.avatar = res.data.info.avatar
                        that.forms.is_check = res.data.info.is_check
                        that.forms.hot_status = res.data.info.hot_status
                        that.forms.over_time = res.data.info.over_time_text
                        that.forms.is_type = res.data.info.is_type
                        that.forms.address = res.data.info.address
                        that.forms.spec_type = res.data.info.spec_type
                        that.forms.default_price = res.data.info.default_price * 1
                        that.forms.province_id = res.data.info.province_id
                        that.forms.area_id = res.data.info.area_id
                        that.forms.city_id = res.data.info.city_id
                        that.forms.tel = res.data.info.tel
                        that.forms.bg_status = res.data.info.bg_status
                        that.forms.content = res.data.info.content
                        that.forms.time = res.data.info.time_text
                        that.content = res.data.info.content
                        if(res.data.info.spec){
                            that.fees = JSON.parse(res.data.info.spec)
                        }
                        that.imgs = res.data.info.images.split(",").filter(item => item.trim());
                        that.checked3 = res.data.info.is_check == 1 ? true : false
                        that.checked2 = res.data.info.hot_status == 1 ? true : false
                        that.checked10 = res.data.info.spec_type == 20 ? true : false
                        that.accate = res.data.category
                        that.areaValue.push(res.data.info.province_id)
                        that.areaValue.push(res.data.info.city_id)
                        that.areaValue.push(res.data.info.area_id)
                        that.fullName = res.data.info.province_name + '/'+res.data.info.city_name +"/" + res.data.info.area_name
                        that.gnar.forEach((v, i) => {
                            if (res.data.info.bg_status.includes(v.id)) {
                                v.checked = true
                            } else {
                                v.checked = false
                            }
                        })
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            subThis(e) {
                let that = this
                if (that.hasRead == false) {
                    this.$message.error('请仔细阅读相关协议')
                    return
                }
                let ar = []
                that.gnar.forEach((v, i) => {
                    if (v.checked) {
                        ar.push(v.id)
                    }
                })
                let data = that.forms
                data.content = that.content
                data.province_id = that.areaValue[0]
                data.city_id = that.areaValue[1]
                data.area_id = that.areaValue[2]
                data.spec = JSON.stringify(that.fees)
                data.spec_type = that.checked10 ? 20 : 10
                data.images = that.imgs.join()
                data.bg_status = ar.join()
                data.hot_status = that.checked2 ? 1 : 2
                data.is_check = that.checked3 ? 1 : 2
                data.source = e
                data.id = that.id
                pubActivity(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        setTimeout(() => {
                            that.$router.push('/punSuccess')
                        }, 2000)
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            delThis(e) {
                this.fees.splice(e, 1)
            },
            plusTicket() {
                let that = this
                let obj = {}
                obj.money = ""
                obj.name = ""
                that.fees.push(obj)
            },
            // 点击工具栏图片按钮，打开弹窗
            openUploadDialog() {
                console.log(123)
                this.dialogVisible = true
                this.fileList = []
                this.uploadImgUrl = []
            },
            // 图片上传成功回调
            uploadSuccess(res) {
                let that = this
                console.log(that.$img(res.data.url))
                if (res.code == 1) {
                    that.uploadImgUrl.push(that.$img(res.data.url))
                } else {
                    // this.$message.error(res.msg || '图片上传失败')
                }
            },
            // 确认插入图片到富文本
            confirmUpload() {
                let that = this
                if (!this.uploadImgUrl) {
                    this.$message.warning('请先上传图片')
                    return
                }
                // 获取编辑器实例
                const quill = this.$refs.myQuillEditor.quill
                console.log("quill", quill)
                // 获取光标位置，插入图片
                let cursorIndex = quill.getSelection()?.index || 0
                console.log("cursorIndex", cursorIndex)
                that.uploadImgUrl.forEach((v, i) => {
                    quill.insertEmbed(cursorIndex, 'image', v)
                    quill.setSelection(cursorIndex + 1)
                })

                this.dialogVisible = false
            },

            // 编辑器事件
            onEditorBlur(editor) {
                console.log('失去焦点', editor)
            },
            onEditorFocus(editor) {
                console.log('获得焦点', editor)
            },
            onEditorChange(editor) {
                // content自动同步，此处可实时校验
                // console.log('内容改变', this.content)
            },

            // 提交
            submitData() {
                if (!this.content) {
                    this.$message.warning('请填写内容')
                    return
                }
                console.log('最终HTML内容：', this.content)
                // 此处调接口提交 this.content
                this.$message.success('提交成功')
            },
            // 清空编辑器
            resetEditor() {
                this.content = ''
            },
            handleAreaChange(val, selectedNodes) {
                console.log(this.areaValue)
            },
            torules(e) {
                let that = this
                that.$router.push({
                    path: '/rules', // 写路由path
                    query: {
                        type: e
                    }
                })
            },

            handleAvatarSuccess(e) {
                let that = this
                if (e.code == 1) {
                    that.imgs.push(e.data.url)
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 3 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }

                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }

                // 校验通过，允许上传
                return true
            },
            beforeAvatarUpload1(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 7 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }
                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }
                // 校验通过，允许上传
                return true
            },
            handleAvatarSuccess1(e) {
                let that = this
                if (e.code == 1) {
                    that.forms.avatar = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
        }
    }
</script>

<style scoped>
    .bot .el-button {
        width: 209px !important;
        height: 46px !important;
    }

    .rules {
        margin-top: 24px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .shne {
        height: 46px;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #D9D9D9;
        font-weight: 500;
        font-size: 14px;
        color: #141933;
        line-height: 46px;
        box-sizing: border-box;
        padding: 0 20px;

    }

    .gnitem {
        margin-right: 50px;
        margin-bottom: 24px;
    }

    .gnLeft {
        width: 229px;
        height: 46px;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 0 20px;
        font-size: 14px;
        line-height: 46px;
        border: 1px solid #D9D9D9;
        margin-right: 16px;
        text-align: left;
    }

    .gtns {
        flex-wrap: wrap;
        width: 750px;
    }

    .gts {
        width: 900px;
        flex-wrap: wrap;
    }

    .gitem {
        margin-bottom: 24px;
        width: 141px;
        height: 46px;
        border-radius: 6px;
        border: 1px solid #D9D9D9;
        line-height: 46px;
        box-sizing: border-box;
        padding: 0 20px;
        font-weight: 500;
        font-size: 14px;
        color: #222222;
        margin-right: 24px;
    }

    .catea {
        background: #E6F2FF !important;
        color: #007AFF !important;
        border: 1px solid #007AFF !important;
    }

    .labels {
        width: 700px;
        flex-wrap: wrap;
    }

    .labelItem {
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        height: 46px;
        line-height: 46px;
        background: #F3F3F3;
        border-radius: 23px;
        border: 1px solid #f3f3f3;
        box-sizing: border-box;
        padding: 0 20px;
        margin-right: 14px;
        cursor: pointer;
        margin-bottom: 24px;
    }

    /* 控制编辑器高度 */
    /deep/ .quill-editor {
        height: 400px;
    }

    /* 工具栏底部边框 */
    /deep/ .ql-toolbar.ql-snow {
        border: 1px solid #e4e7ed;
        border-bottom: none;
    }

    /* 编辑区域边框 */
    /deep/ .ql-container.ql-snow {
        border: 1px solid #e4e7ed;
        min-height: 320px;
    }

    .imgItme {
        width: 167px;
        height: 97px;
        margin-left: 20px;
        position: relative;
    }

    .dels {
        position: absolute;
        width: 20px;
        height: 20px;
        background: rgba(0, 0, 0, 0.39);
        right: 8px;
        top: 8px;
        z-index: 2;
        cursor: pointer;
    }

    .imgItme img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    .taAdd {
        padding: 20px 0;
    }

    .bdright {
        border-right: 1px solid #D9D9D9;
    }

    .bdbottom {
        border-bottom: 1px solid #D9D9D9;
    }

    .bTable {
        border: 1px solid #d9d9d9;

    }

    .bip1 {
        width: 316px;
        box-sizing: border-box;
        padding: 20px;
    }

    .bip1 input {
        border: 1px solid #D9D9D9;
        width: 100%;
        height: 46px;
        text-align: center;
    }

    .bip2 input {
        border: 1px solid #D9D9D9;
        width: 100%;
        height: 46px;
        text-align: center;
    }

    .bip2 {
        width: 172px;
        box-sizing: border-box;
        padding: 20px;
    }

    .bip3 {
        width: 148px;
        text-align: center;
    }

    .btt1 {
        width: 316px;
        height: 46px;
        text-align: center;
        line-height: 46px;
    }

    .tabdel {
        width: 18px;
        height: 18px;
    }

    .btt2 {
        width: 172px;
        height: 46px;
        text-align: center;
        line-height: 46px;
    }

    .btt3 {
        width: 148px;
        height: 46px;
        text-align: center;
        line-height: 46px;
    }

    .btTitle {
        background: #f6f6f6;
        color: #C3C5CD;
        font-size: 14px;
    }

    .tip {
        font-size: 14px;
        color: #999999;
        margin-top: 12px;
        text-align: left;
    }

    .bot .el-button {
        width: 209px !important;
        height: 46px !important;
    }

    .rules {
        margin-top: 24px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .formitem {
        margin-bottom: 30px;
    }

    .tis .tiitem {
        font-size: 12px;
        color: #838383;
        text-align: left;
        line-height: 24px;
        margin-left: 20px;
    }

    .finame {
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        width: 258px;
        text-align: right;
    }

    .ips .inps {
        width: 300px;
        height: 46px;
    }

    .upimage {
        width: 167px;
        height: 97px;
    }

    .upimage img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .formTitle {
        margin-bottom: 31px;
    }

    .ftname {
        font-weight: 500;
        font-size: 18px;
    }

    .upload-demo {
        width: 167px !important;
        height: 97px !important;
    }

    .bshu {
        width: 3px;
        height: 16px;
        background: #007AFF;
        margin-right: 12px;
    }

    .forms {
        width: 1460px;
        background-color: #fff !important;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 64px 40px;
    }
</style>